export const SIGN_UP_EMAIL_STORAGE_KEY = 'signUpEmail'
